import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import { keyMapsMutation } from "../../helpers/storeKeys";
import { CartErrorMessages } from "../../helpers/messageConstants";
export default {
  namespaced: true,
  state: {
    previousOrderData: [],
    editPreviousOrderData: {
      netPrice: "",
      totalItems: "",
      orderTime: "",
      currentCartData: [],
    },
    hasNext: false,
    nextPage: 1,
    reorderData: {},
    reorderFilters: [],
  },
  getters: {
    currentCartTotal: (state) => {
      return state.editPreviousOrderData.currentCartData
        .reduce((acc, cartItem) => {
          return cartItem.quantity * cartItem.itemPrice + acc;
        }, 0)
        .toFixed(2);
    },
  },
  mutations: {
    updateReOrderData(state, payload) {
      state.previousOrderData = payload;
    },
    updateReorderFilters(state, payload) {
      state.reorderFilters = payload;
    },
    updateReOrderDataResponse(state, payload) {
      state.reorderData = payload;
    },
    addPreviousOrderData(state, payload) {
      // const {} = payload;
      // debugger
      let item = state.editPreviousOrderData.currentCartData.find((i) => {
        if (
          i.id === payload.id
          // i.crustId === payload.crustId &&
          // i.sizeId === payload.sizeId &&
          // i.addTopngs.sort().toString() == payload.addTopngs.sort().toString() //  compare of addTopngs with prev toppings
        ) {
          return i;
        }
      });

      if (item) {
        item.quantity++;
      } else {
        state.editPreviousOrderData.currentCartData.push({
          ...payload,
          quantity: 1,
        });
        state.editPreviousOrderData.currentCartData = Array.from(
          new Set(
            state.editPreviousOrderData.currentCartData.map(JSON.stringify)
          )
        ).map(JSON.parse);
      }
    },
    removePreviousOrderData(state, payload) {
      let item = state.editPreviousOrderData.currentCartData.find(
        (i) => i.id === payload.id
      );

      if (item) {
        if (item.quantity > 1) {
          item.quantity--;
        } else {
          state.editPreviousOrderData.currentCartData =
            state.editPreviousOrderData.currentCartData.filter(
              (i) => i.id !== payload.id
            );
        }
      }
    },
    resetCartItemData(state) {
      state.editPreviousOrderData.currentCartData = [];
    },
    updateCurrentItemDetails(state, payload) {
      state.editPreviousOrderData.netPrice = payload.netPrice;
      state.editPreviousOrderData.totalItems = payload.totalItems;
      state.editPreviousOrderData.orderTime = payload.orderTime;
    },
    resetCurrentItemDetails(state) {
      state.editPreviousOrderData.netPrice = "";
      state.editPreviousOrderData.totalItems = "";
      state.editPreviousOrderData.orderTime = "";
    },
    updateAndCheckCurrent(state, payload) {
      state.editPreviousOrderData.currentCartData = payload;
    },
    updateHasNext(state, payload) {
      state.hasNext = payload || false;
    },
    updateNextPage(state, payload) {
      state.nextPage = payload;
    },
    appendReOrderData(state, payload) {
      let orders = state.previousOrderData;
      state.previousOrderData = [...state.previousOrderData, ...payload];
    },
  },
  actions: {
    getReOrderData({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      let userData = LocalStorageFunc.getUserData();
      apiCalls
        .PREVIOUS_ORDER_API({
          headers: Headers({ withMobileNo: true }),
          payload: {
            userId: userData?.headers?.userId,
            filterKey: payload?.filterKey,
            filterValue: payload?.filterValue,
          },
        })
        .then(function (response) {
          if (response?.data?.orders) {
            commit("updateReOrderData", response?.data?.orders);
            commit("updateReorderFilters", response?.data?.filter);
            response?.data?.orders?.map((order) => {
              if (
                order?.currentOrder == 1 ||
                (order?.advanceOrder && order?.advanceOrderInProgress)
              ) {
                LocalStorageFunc.setOrderSummary(order);
                commit(
                  keyMapsMutation.UPDATE_NOTIFICATION_STATUS_DATA,
                  Utility.getInlineNotificationObjectForClientMsg({
                    title: "Your Order is on the way",
                    page: "home",
                    actionUrl: "/order-tracking",
                    actionLabel: "Track",
                  }),
                  { root: true }
                );
              }
            });
          } else {
            commit("updateReOrderData", []);
          }
          if (response?.data?.hasNext) {
            commit("updateHasNext", response?.data?.hasNext);
          }
          if (response?.data?.nextPage) {
            commit("updateNextPage", response?.data?.nextPage);
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
    getOrderDetailsData({ commit }, payload) {
      let userData = LocalStorageFunc.getUserData();
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .PREVIOUS_ORDER_DETAILS_API({
          headers: Headers({ withMobileNo: true }),
          payload: {
            userId: userData?.headers?.userId,
            id: payload,
          },
        })
        .then(function (response) {
          if (response?.data?.orderDetails) {
            LocalStorageFunc.setOrderSummary(response?.data?.orderDetails);
            commit(
              "OrderTracking/updateTrackOrder",
              {
                orderSummary: response?.data?.orderDetails,
              },
              { root: true }
            );
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
    getNextOrderBatchData({ commit, state }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      let userData = LocalStorageFunc.getUserData();
      apiCalls
        .PREVIOUS_ORDER_BY_PAGE_API({
          headers: Headers({ withMobileNo: true }),
          payload: {
            userId: userData?.headers?.userId,
            pageNo: state.nextPage,
            filterKey: payload?.filterKey,
            filterValue: payload?.filterValue,
          },
        })
        .then(function (response) {
          if (response?.data?.orders) {
            commit("appendReOrderData", response?.data?.orders);
          }
          if (response?.data) {
            commit("updateHasNext", response?.data?.hasNext);
          }
          if (response?.data?.nextPage) {
            commit("updateNextPage", response?.data?.nextPage);
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
          //console.log("error",error)
          //let tempResult = PreviousOrderData;
          //commit("updateReOrderData", tempResult?.orders);
          // commit("updateReOrderData", response?.data);
          /* console.log("There is some network error", error); */
        });
    },
    getPreviousSingleOrder({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .PREVIOUS_SINGLE_ORDER_API({
          headers: Headers({ withMobileNo: true }),
          payload: {
            limit: 10,
            storeId: LocalStorageFunc.storeId(),
            deliveryType: LocalStorageFunc.getDeliveryType(),
          },
        })
        .then(function (response) {
          if (response?.data?.data) {
            commit("updateReOrderData", response?.data?.data);
          }
          commit("updateReOrderDataResponse", response?.data);
          commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, response?.data, {
            root: true,
          });
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
    reorderItems({ commit, state }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .REORDER_ITEMS_API({
          headers: Headers({ withMobileNo: true }),
          payload: {
            orderId: payload,
          },
        })
        .then(function (response) {
          if (response?.response?.status >= 500) {
            commit(keyMapsMutation.UPDATE_CART_ERROR, true);
            return;
          }
          if (response?.data?.data?.cart) {
            LocalStorageFunc.setCartId(response?.data?.data?.cart.cartId);
            commit(
              "Cart/updateCartItemsPrice",
              response?.data?.data?.cart.validItems,
              {
                root: true,
              }
            );
            if (response?.data?.data?.cart?.validItems) {
              commit(
                "Cart/updateValidItems",
                response?.data?.data?.cart?.validItems,
                {
                  root: true,
                }
              );
            }
            if (response?.data?.data?.cart?.inValidItems) {
              commit(
                "Cart/updateInvalidItems",
                response?.data?.data?.cart?.inValidItems,
                {
                  root: true,
                }
              );
            }
            if (
              response?.data?.data?.cart?.discountAllocations?.[0]
                ?.confettiMessage
            ) {
              commit(
                "Cart/updateAmountSavedMsg",
                response?.data?.data?.cart?.discountAllocations?.[0]
                  ?.confettiMessage,
                { root: true }
              );
            }
            if (
              response?.data?.data?.cart?.status === "FAILED" &&
              !response?.data?.data?.cart?.inValidItems?.length
            ) {
              commit(
                "Cart/updateDisplayErrorMsg",
                response?.data?.data?.cart?.errorMessages?.[0]?.message,
                { root: true }
              );
            }
            if (
              response?.data?.data?.cart?.baseCalculationsMap?.grand_total
                ?.roundedValue
            ) {
              commit(
                "Cart/updateCartTotalPrice",
                response?.data?.data?.cart?.baseCalculationsMap?.grand_total
                  ?.roundedValue,
                { root: true }
              );
            }
            if (
              response?.data?.data?.cart?.baseCalculationsMap?.grand_total
                ?.discount
            ) {
              commit(
                "Cart/updateOfferDiscount",
                response?.data?.data?.cart?.baseCalculationsMap?.grand_total
                  ?.discount,
                { root: true }
              );
            }
            if (
              response?.data?.data?.cart?.explicitPromo &&
              response?.data?.data?.cart?.explicitPromo?.errors
            ) {
              commit(
                "Offers/updateOfferFailedMsg",
                "Invalid promo. " +
                  response?.data?.data?.cart?.explicitPromo?.errors[0]
                    ?.displayMsg,
                { root: true }
              );
              commit("Offers/updateShowOfferFailedMsg", true, { root: true });
              setTimeout(() => {
                commit("Offers/updateShowOfferFailedMsg", false, {
                  root: true,
                });
              }, 3000);
            }
            commit("Cart/updateCartItemResponse", response?.data?.data?.cart, {
              root: true,
            });

            commit(
              "Cart/updateCartItemsFromGetCart",
              response?.data?.data?.cart,
              {
                root: true,
              }
            );
            commit(
              "Cart/updateTipAmountOptions",
              response?.data?.data?.cart?.tipsMetadata?.tipMainLayout
                ?.tipsAmountOption?.amountOptions,
              { root: true }
            );
            if (payload?.isRedirectToPayment) {
              Utility.redirectToPaymentPage();
            }
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
          dispatch(
            keyMapsActionPayment.GET_INIT_CART_SPECIFIC_FOR_PAYMENT,
            response,
            {
              root: true,
            }
          );
          LocalStorageFunc.setReorderedItems("");
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
          LocalStorageFunc.setReorderedItems("");
        });
    },
  },
};
